import { render } from "./billingset-list.vue?vue&type=template&id=0bb97e92"
import script from "./billingset-list.vue?vue&type=script&lang=js"
export * from "./billingset-list.vue?vue&type=script&lang=js"

import "./billingset-list.vue?vue&type=style&index=0&id=0bb97e92&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__